export default __webpack_public_path__ + "static/media/aktiv-grotesk-bold.84c4b2a1.woff";